import React from 'react';
import { Button, Card, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaTimesCircle } from 'react-icons/fa';

export default function Failure() {
    return (
        <div style={{ minHeight: 'calc(100vh - 281px)', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <Container className="d-flex flex-column align-items-center">
                <Card style={{ width: '22rem', textAlign: 'center', padding: '20px', borderRadius: '10px', boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)' }}>
                    <FaTimesCircle size={60} color="red" />
                    <Card.Body>
                        <Card.Title style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>Pago rechazado</Card.Title>
                        <Card.Text style={{ color: '#555' }}>
                            No pudimos procesar tu pago.  
                            Por favor, verifica tu información y vuelve a intentarlo.
                        </Card.Text>
                        <Button variant="danger" as={Link} to="/">Intentar de nuevo</Button>
                    </Card.Body>
                </Card>
            </Container>
        </div>
    );
}
